<template>
  <div
    v-if="active"
    class="bsod"
  >
    <div
      class="text-container"
    >
      <h2
        class="header"
        style="font-family: monospace;"
      >
        ERROR CODE NOT FOUND
      </h2>
      <p
        class="message"
        style="font-family: monospace;"
      >
        The system has experienced in error in locating the requested resource: C:\HLT\mastery\konami-code.exe does not exist.
      </p>
      <p
        class="message"
        style="font-family: monospace;"
      >
        If the issue persists, contact your system administrator.
      </p>
      <button
        class="dismiss-button"
        style="font-family: monospace;"
        @click="dismiss"
      >
        Goodbye
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BSOD',
  computed: {
    active() {
      return this.$store.getters['ui/showBlueScreen'];
    },
  },
  methods: {
    dismiss() {
      this.$store.commit('ui/setShowBlueScreen', false);
    },
  },
};
</script>

<style scoped lang="scss">
.bsod {
  align-items: center;
  background-color: #051DB5;
  bottom: 0;
  display: flex;
  justify-content: center;
  left: 0;
  position: absolute;
  right: 0;
  top: 0;
  z-index: 99999;

  .text-container {
    align-items: center;
    text-align: left;
    color: #dddddd;
    display: flex;
    flex-direction: column;
    font-weight: $bold;
    justify-content: center;
    max-width: 800px;

    .header {
      background-color: #dddddd;
      color: #051DB5;
      display: inline-block;
      font-size: 24px;
      margin: 0 auto;
      padding: 4px 8px;
      text-align: center;
    }

    .message {
      display: block;
      font-size: 20px;
      width: 100%;
    }

    .dismiss-button {
      background-color: #dddddd;
      color: #051DB5;
      display: block;
      font-size: 20px;
      font-weight: $bold;
      margin: 0 auto;
      padding: 8px 16px;
    }
  }
}
</style>
